import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, OnDestroy } from '@angular/core';

// We need to define it as a component to use the angular hooks.
@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export abstract class StepManager implements OnDestroy {
  readonly steps;
  public step$: BehaviorSubject<string> = new BehaviorSubject(null);
  public activeStep: string;
  public previousStep: string;
  public nextStep: string;

  protected notifier = new Subject<void>();
  private titlePath: string;

  // Todo: See if these values can be injected instead of inheritance.
  protected constructor(
    protected location: Location,
    protected router: Router,
    private title: Title,
    protected translate: TranslateService
  ) {
    this.translate.onLangChange.pipe(takeUntil(this.notifier)).subscribe(() => {
      this.title.setTitle(this.translate.instant(this.titlePath));
    });
  }

  ngOnDestroy(): void {
    this.notifier.next();
    this.notifier.complete();
  }

  protected goToStep(step: string): void {
    this.step$.next(step);
    // @Todo we can do these actions by listening to the observable.
    this.previousStep = this.activeStep;
    this.activeStep = step || this.nextStep;
    this.updateUrl(this.previousStep, this.activeStep);
  }

  protected setTitle(titlePath: string) {
    this.titlePath = titlePath;
    this.title.setTitle(this.translate.instant(this.titlePath));
  }

  private updateUrl(currentPath: string, newPath: string) {
    currentPath = currentPath ? currentPath.split('?')[0] : undefined;
    const url = window.location.pathname.replace(currentPath, newPath) + window.location.search;
    window.history.pushState({}, newPath, url);
  }
}
